export enum EventNames {
  CARD_ONCLICK = "card_click",
  BTN_ONCLICK = "btn_click",
  CHART_FILTER = "chart_filter",
  SAFE_SPACE_CLICK = "safe_spaces_click",
  WISDOM_AI_CLICK = "wisdom_AI_click",
  BRIGHT_EX_CLICK = "bright_exchange_click",
  PHONE_CALL_START = "start_phone_call",
  EMAIL_START = "start_email_messaging",
  LIVE_CHAT_START = "start_live_chat",
  LIVE_CHAT_END = "end_live_chat",
  VIDEO_CHAT_START = "start_video_chat",
  VIDEO_CHAT_END = "end_video_chat",
  RESOURCE_FILTER = "resource_filter",
  RESOURCE_CLICK = "resource_click",
  SUPPORT_CLICK = "support_click",
  SUPPORT_MOMENTS_CLICK = "support_moments_click",
  FORM_SUBMIT = "form_submit",
  NAV_SEARCH = "nav_search",
  BREATHING_EXERCISE_START = "start_breathing_exercise",
  BREATHING_EXERCISE_COMPLETE = "complete_breathing_exercise",
  MINI_HEALTH_CHECK_START = "start_mini_health",
  MINI_HEALTH_CHECK_END = "complete_mini_health",
  HEALTH_DATA_SAVE = "save_health_data",
  SAVE_HEALTH_DATA_GOAL = "save_health_data_goal",
  PREVIEW_LEADERBOARD = "preview_leaderboard",
  START_PASSWORD_CHANGE = "start_password_change",
  START_SINGLE_SIGNON = "start_single_signon",
  SETUP_TWO_FA = "setup_two_factor_auth",
  VERIFY_TWO_FA = "verify_two_factor_auth",
  DEACTIVATE_TWO_FA = "deactivate_two_factor_auth",
  CANCEL_DEACTIVATE_TWO_FA = "cancel_deactivate_two_fa",
  COMPLETE_DEACTIVATE_TWO_FA = "complete_deactivate_two_fa",
  GENERATE_NEW_RECOVERY_CODES = "generate_new_recovery_codes",
  COPY_RECOVERY_CODES = "copy_recovery_codes",
  DOWNLOAD_RECOVERY_CODES = "download_recovery_codes",
  COMPLETE_RECOVERY_CODES_PROCESS = "complete_recovery_codes_process",
  AUTHENTICATOR_ON_APPSTORE = "authenticator_on_appstore",
  AUTHENTICATOR_ON_PLAYSTORE = "authenticator_on_playstore",
  PASSWORD_CHANGE_SUBMIT = "password_change_submit",
  PASSWORD_CHANGE_OPEN = "password_change_open",
  SSO_SETUP = "sso_setup",
  SSO_UNLINK = "sso_unlink",
  WHATSNEW_INTERESTED = "whatsnew_interested",
  WHATSNEW_DISMISSED = "whatsnew_dismissed",
  WHATSNEW_NOT_INTERESTED = "whatsnew_not_interested",
  WHATSNEW_REMIND_LATER = "whatsnew_remind_later",
  CHANGE_ORGANISATION = "change_organisation",
  CONFIRM_CHANGE_ORGANISATION = "confirm_change_organisation",
  RESET_ORGANISATION_CODE = "reset_organisation_code",
  FIND_OUT_MORE = "find_out_more",
  FIND_OUT_MORE_LOCALE_SELECT = "find_out_more_locale_select",
  LOGOUT = "logout",
  MANUAL_LOCALE_SELECT = "manual_locale_select",
  BIOMETRIC_ENABLED = "biometric_enabled",
  BIOMETRIC_DISABLED = "biometric_disabled",
  BIOMETRIC_SETUP = "biometric_setup",
  BIOMETRIC_SETUP_FAILED = "biometric_setup_failed",
  DAILY_ACTIVE_USAGE = "daily_active_usage",
  SSO_CLIENT_CODE_CONFLICT_AUTH_ERROR = "sso_client_code_conflict_auth_error",
  SSO_CLIENT_CODE_CONFLICT_CHANGE_ORG_BLOCKED = "sso_client_code_conflict_change_org_blocked",
  SENDGRID_EMAIL_CLICK = "sendgrid_email_click",
  WISDOM_APPSTORE_CLICK = "wisdom_appstore_click",
  WISDOM_PLAYSTORE_CLICK = "wisdom_playstore_click",
  EQUALWEB_DRAWER_OPEN = "equal_web_drawer_open",
  EQUALWEB_DRAWER_CLOSE = "equal_web_drawer_close",
  APP_DOWNLOAD = "app_download",
  MOOD_SUPPORT_MODAL_SKIP = "mood_support_modal_skip",
  MOOD_SUPPORT_MODAL_CLOSE = "mood_support_modal_close",
  MOOD_SUPPORT_MODAL_CONTACT_US = "mood_support_modal_contact_us",
  MOOD_JOURNEY_MODAL_DISMISSED = "mood_journey_modal_dismissed",
  MOOD_MODAL_VIEWED = "mood_modal_viewed",
  EXPERIENCE_THUMBS_UP = "experience_thumbs_up",
  EXPERIENCE_THUMBS_DOWN = "experience_thumbs_down",
  CLOSE_EXPERIENCE_MODAL = "close_experience_modal",
  SHOW_EXPERIENCE_MODAL = "show_experience_modal",
  APP_EXPERIENCE_FEEDBACK = "app_experience_feedback",
  DISMISS_EXPERIENCE_FEEDBACK = "dismiss_experience_feedback",
  EXPERIENCE_FEEDBACK_ERROR = "experience_feedback_error",
  WHATSAPP_CLICK = "whatsapp_click",
  WHATSAPP_REDIRECT = "whatsapp_redirect",
  WISDOM_ACADEMY_COMING_SOON_VIEWED = "wisdom_academy_coming_soon_viewed",
  WISDOM_ACADEMY_COMING_SOON_INTERESTED = "wisdom_academy_coming_soon_interested",
  WISDOM_ACADEMY_COMING_SOON_NOT_INTERESTED = "wisdom_academy_coming_soon_not_interested",
  WISDOM_ACADEMY_COMING_SOON_DISMISSED = "wisdom_academy_coming_soon_dismissed",
  WISDOM_AI_COMING_SOON_VIEWED = "wisdom_ai_coming_soon_viewed",
  WISDOM_AI_COMING_SOON_INTERESTED = "wisdom_ai_coming_soon_interested",
  WISDOM_AI_COMING_SOON_NOT_INTERESTED = "wisdom_ai_coming_soon_not_interested",
  WISDOM_AI_COMING_SOON_DISMISSED = "wisdom_ai_coming_soon_dismissed",
  WISDOM_AI_CARD_CLICK = "wisdom_ai_card_click",
  WISDOM_AI_NAV_CLICK = "wisdom_ai_nav_click",
  CREATE_POSITIVE_YOU = "create_positive_you",
  EDIT_POSITIVE_YOU = "edit_positive_you",
  DELETE_POSITIVE_YOU = "delete_positive_you",
  NAV_CLICK = "nav_click",
  POSITIVE_YOU_INFO = "positive_you_info",
  POSITIVE_YOU_JOURNAL_CLICK = "positive_you_journal_click",
  POSITIVE_YOU_NEW_ENTRY_CLICK = "positive_you_new_entry_click",
  POSITIVE_YOU_CALENDAR_DATE_SELECTED = "positive_you_calendar_date_selected",
  WISDOM_ACADEMY_COURSE_STARTED = "wisdom_academy_course_started",
  WISDOM_ACADEMY_COURSE_COMPLETE = "wisdom_academy_course_complete",
  WISDOM_ACADEMY_COURSE_UNCOMPLETE = "wisdom_academy_course_uncomplete",
  WISDOM_ACADEMY_LEAVE_COURSE = "wisdom_academy_leave_course",
  LIVE_CHAT_THUMBS_UP = "live_chat_thumbs_up",
  LIVE_CHAT_THUMBS_DOWN = "live_chat_thumbs_down",
  LIVE_CHAT_DISMISS = "live_chat_dismiss",
  SUPPORT_MOMENT_LEAVE = "support_moment_leave",
  SUPPORT_MOMENTS_COACHMARK_VIEWED = "support_moments_coachmark_viewed",
  SUPPORT_MOMENTS_COACHMARK_NEXT = "support_moments_coachmark_next",
  SUPPORT_MOMENTS_COACHMARK_SKIP = "support_moments_coachmark_skip",
  SUPPORT_MOMENTS_COACH_MARK_COMPLETED = "support_moments_coach_mark_completed",
  SUPPORT_MOMENTS_OUTCOME_VIEWED = "support_moments_outcome_viewed",
  SUPPORT_MOMENTS_OUTCOME_BUTTON_CLICK = "support_moments_outcome_button_click",
  SUPPORT_MOMENTS_CHECKIN_OPTION_SELECTED = "support_moments_checkin_option_selected",
  SUPPORT_MOMENTS_CHECKIN_FINISH = "support_moments_checkin_finish",
  SUPPORT_MOMENTS_OPTION_SELECTED = "support_moments_option_selected",
  SUPPORT_MOMENTS_NOT_SURE_OPTION_SELECTED = "support_moments_not_sure_option_selected",
  AUDIO_START = "audio_start",
  AUDIO_PLAYER_INTERACTION = "audio_player_interaction",
  TRACK_YOUR_WELLBEING_INFO_OPENED = "track_your_wellbeing_info_opened",
}
